export default class Popup {
  constructor(type, pathQueryMap, detail) {
    this.type = type;
    this.pathQueryMap = pathQueryMap;
    if (detail) this._detail = detail;
    this.createComponent = this.createComponent.bind(this);
    this.setAttributes = this.setAttributes.bind(this);
  }

  createComponent() {}

  setAttributes(popupComponent, details) {}
}
